import React from "react";
import { Navigate } from "react-router-dom";

// Pages Component
import Chat from "../pages/Chat/Chat";

// Profile
import UserProfile from "../pages/Authentication/user-profile";

// Pages Calendar
import Calendar from "../pages/Calendar/index";

//Email
import EmailRead from "../pages/Email/email-read";
import EmailBasicTemplte from "../pages/Email/email-basic-templte";
import EmailAlertTemplte from "../pages/Email/email-template-alert";
import EmailTemplateBilling from "../pages/Email/email-template-billing";

//Invoices
import InvoicesList from "../pages/Invoices/invoices-list";
import InvoiceDetail from "../pages/Invoices/invoices-detail";
import InvoicePage from "../pages/Invoices/InvoicePage";
import InvoiceManager from "../pages/Invoices/InvoiceManager"
import InvoiceClient from "../pages/Invoices/InvoiceClient"

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import AdminRegister from "../pages/Authentication/AdminRegister"
import ClientRegister from "../pages/Authentication/ClientRegister"
import ForgetPwd from "../pages/Authentication/ForgetPassword";

//  // Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login";
import Login2 from "../pages/AuthenticationInner/Login2";
import Register1 from "../pages/AuthenticationInner/Register";
import Register2 from "../pages/AuthenticationInner/Register2";
import Recoverpw from "../pages/AuthenticationInner/Recoverpw";
import Recoverpw2 from "../pages/AuthenticationInner/Recoverpw2";
import ForgetPwd1 from "../pages/AuthenticationInner/ForgetPassword";
import ForgetPwd2 from "../pages/AuthenticationInner/ForgetPassword2";
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";
import LockScreen2 from "../pages/AuthenticationInner/auth-lock-screen-2";
import ConfirmMail from "../pages/AuthenticationInner/page-confirm-mail";
import ConfirmMail2 from "../pages/AuthenticationInner/page-confirm-mail-2";
import EmailVerification from "../pages/AuthenticationInner/auth-email-verification";
import EmailVerification2 from "../pages/AuthenticationInner/auth-email-verification-2";
import TwostepVerification from "../pages/AuthenticationInner/auth-two-step-verification";
import TwostepVerification2 from "../pages/AuthenticationInner/auth-two-step-verification-2";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

import TopJobsChart from "../pages/Dashboard/TopJobsChart"


import CompletedJobsByTimesheetStatus from "../pages/Allocate/CompletedJobsByTimesheetStatus";

//Organisation
import organisation from "../pages/Organisation/index";


//BusinessUnit
import businessunit from "../pages/BusinessUnit/index"

import workers from "../pages/Workers/index";
import Users from "../pages/Authentication/Users"


import CreateEmailTemplateForm from "../pages/Email/CreateEmailTemplateForm"
// Charts
import ChartApex from "../pages/Charts/Apexcharts";
import ChartjsChart from "../pages/Charts/ChartjsChart";
import EChart from "../pages/Charts/EChart";
import SparklineChart from "../pages/Charts/SparklineChart";
import ChartsKnob from "../pages/Charts/charts-knob";
import ReCharts from "../pages/Charts/ReCharts";

// Maps
import MapsGoogle from "../pages/Maps/MapsGoogle";

//Icons
import IconBoxicons from "../pages/Icons/IconBoxicons";
import IconDripicons from "../pages/Icons/IconDripicons";
import IconMaterialdesign from "../pages/Icons/IconMaterialdesign";
import IconFontawesome from "../pages/Icons/IconFontawesome";

//Tables
import BasicTables from "../pages/Tables/BasicTables";
import DatatableTables from "../pages/Tables/DatatableTables";

//Job
import JobGrid from "../pages/JobPages/JobGrid/index";
import JobDetails from "../pages/JobPages/JobDetails";
import JobCategories from "../pages/JobPages/JobCategories";
import JobListing from "../pages/Jobs/JobListing";
import ApplyJobs from "../pages/JobPages/ApplyJobs/index";
import CandidateOverview from "../pages/JobPages/CandidateOverview";

// Forms
import FormElements from "../pages/Forms/FormElements";
import FormLayouts from "../pages/Forms/FormLayouts";
import FormAdvanced from "../pages/Forms/FormAdvanced";
import FormEditors from "../pages/Forms/FormEditors";
import FormValidations from "../pages/Forms/FormValidations";
import FormMask from "../pages/Forms/FormMask";
import FormRepeater from "../pages/Forms/FormRepeater";
import FormUpload from "../pages/Forms/FormUpload";
import FormWizard from "../pages/Forms/FormWizard";

//Ui
import UiAlert from "../pages/Ui/UiAlert";
import UiButtons from "../pages/Ui/UiButtons";
import UiCards from "../pages/Ui/UiCards";
import UiCarousel from "../pages/Ui/UiCarousel";
import UiColors from "../pages/Ui/UiColors";
import UiDropdown from "../pages/Ui/UiDropdown";
import UiGeneral from "../pages/Ui/UiGeneral";
import UiGrid from "../pages/Ui/UiGrid";
import UiImages from "../pages/Ui/UiImages";
import UiLightbox from "../pages/Ui/UiLightbox";
import UiModal from "../pages/Ui/UiModal";
import UiProgressbar from "../pages/Ui/UiProgressbar";
import UiTabsAccordions from "../pages/Ui/UiTabsAccordions";
import UiTypography from "../pages/Ui/UiTypography";
import UiVideo from "../pages/Ui/UiVideo";
import UiSessionTimeout from "../pages/Ui/UiSessionTimeout";
import UiRating from "../pages/Ui/UiRating";
import UiRangeSlider from "../pages/Ui/UiRangeSlider";
import UiNotifications from "../pages/Ui/ui-notifications";
import UiOffCanvas from "pages/Ui/UiOffCanvas";
import UiUtilitie from "../pages/Ui/UiUtilitie";
import UiPlaceholders from "../pages/Ui/UiPlaceholders";
import UiToasts from "../pages/Ui/UiToast";

//Pages
import PagesStarter from "../pages/Utility/pages-starter";
import PagesMaintenance from "../pages/Utility/pages-maintenance";
import PagesComingsoon from "../pages/Utility/pages-comingsoon";
import PagesTimeline from "../pages/Utility/pages-timeline";
import PagesFaqs from "../pages/Utility/pages-faqs";
import PagesPricing from "../pages/Utility/pages-pricing";
import Pages404 from "../pages/Utility/pages-404";
import Pages500 from "../pages/Utility/pages-500";
import Confirm from "../pages/Utility/confirm";

import Support from "../pages/Support/Support";

import PrivacyPolicy from "../pages/Privacy/PrivacyPolicy";
import PrivacyChoices from "../pages/Privacy/PrivacyChoices";
import UnsubscribePage from "../pages/Unsubscribe/UnsubscribePage";

//Contacts
import ContactsGrid from "../pages/Contacts/contacts-grid";
import ContactsList from "../pages/Contacts/ContactList/contacts-list";
import ContactsProfile from "../pages/Contacts/ContactsProfile/contacts-profile";

import OrganisationManager from "pages/Organisation/OrganisationManager";
import BusinessUnitManager from "pages/BusinessUnit/BusinessUnitManager";
import WorkerManager from "pages/Workers/WorkerManager";
import JobManager from "pages/Jobs/JobManager";
import Booking from "pages/Jobs/Booking"
import ActivityManager from "pages/Activity/ActivityManager";
import JobBoard from "pages/Jobs/JobBoard";
import JobClient from "pages/Jobs/JobClient";
import BookingClient from "pages/Jobs/BookingClient"

import JobAgent from "pages/Jobs/JobAgent";
import JobList from "pages/JobPages/JobList"
import JobWorker from "pages/Jobs/JobWorker";
import AgreementManager from "pages/Agreements/AgreementManager";
import AgreementAgent from "pages/Agreements/AgreementAgent";
import FinanceManager from "pages/Finance/FinanceManager";
import FinanceAgent from "pages/Finance/FinanceAgent";
import TimesheetForm from "pages/Timesheets/TimesheetForm";
import TimesheetManager from "pages/Timesheets/TimesheetManager";
import TimesheetClient from "pages/Allocate/ApproveClientTimesheets"
import TimesheetList from "pages/Timesheets/TimesheetList"
import TimesheetWorker from "pages/Timesheets/TimesheetWorker"
import ApplicationManager from "pages/ApplicationDetail/ApplicationManager";
import ApplicationWorker from "pages/ApplicationDetail/ApplicationWorker"
import WorkerClient from "pages/Workers/WorkerClient";
import Worker from "pages/Workers/Worker";
import AgreementClient from "pages/Agreements/AgreementClient";
import OrganisationClient from "pages/Organisation/OrganisationClient";
import OrganisationAgent from "pages/Organisation/OrganisationAgent";
import WorkerAgent from "pages/Workers/WorkerAgent";
import TimesheetAgent from "pages/Timesheets/TimesheetAgent";
import Schedule from "pages/Timesheets/Schedule";
import ScheduleWorker from "pages/Timesheets/ScheduleWorker";
import Master from "pages/Allocate/Master";
import MasterClient from "pages/Allocate/MasterClient"
import MasterKanban from "pages/Allocate/MasterKanban";
import MasterGantt from "pages/Allocate/MasterGantt";
import MasterWorker from "pages/Allocate/MasterWorker"
import MasterMap from "pages/Allocate/MasterMap"


import ApproveTimesheets from "pages/Allocate/ApproveTimesheets";
import ApproveClientTimesheets from "pages/Allocate/ApproveClientTimesheets"
import ApproveWorkerTimesheets from "pages/Allocate/ApproveWorkerTimesheets"

import Schedul from "pages/Timesheets/Schedul";
import Allocate from "pages/Timesheets/Allocate"

import InvoiceForm from "pages/Invoices/InvoiceForm"
import { components } from "react-trello";
import Email from "pages/Email/email"
import Home from "pages/External/Home";
import AboutUs from "pages/External/AboutUs";
import ROICalculator from "pages/External/ROICalculator"
import BookADemo from "pages/External/BookADemo"
import OurTeam from "pages/External/OurTeam";
import OurStory from "pages/External/OurStory"
import OurBlog from "pages/External/OurBlog"
import OurGuide from "pages/External/OurGuide"
import StaffingService from "pages/External/StaffingService";
import RotaManagement from "pages/External/RotaManagement";
import DigitalTimesheet from "pages/External/DigitalTimesheet";
import ContactUs from "pages/External/ContactUs"
import Recruitment from "pages/External/Recruitment"
import WagesSalaries from "pages/External/WagesSalaries"
import Invoices from "pages/External/Invoices"

import Careers from "pages/External/Careers"
import Press from "pages/External/Press"

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/tjchart", component: <TopJobsChart /> },

  { path: "/organisation", component: <OrganisationManager /> },
  { path: "/businessunit", component: <BusinessUnitManager /> },
  { path: "/workers", component: <WorkerManager /> },
  { path: "/worker", component: <Worker /> },
  { path: "/workerclient", component: <WorkerClient /> },
  { path: "/workeragent", component: <WorkerAgent /> },
  { path: "/jobs", component: <JobManager /> },
  { path: "/jobboard", component: <JobBoard /> },

  { path: "/jobclient", component: <JobClient /> },
  { path: "/bookingclient", component: <BookingClient /> },
  { path: "/jobworker", component: <JobWorker /> },
  { path: "/jobagent", component: <JobAgent /> },
  { path: "/agreements", component: <AgreementManager /> },
  { path: "/finance", component: <FinanceManager /> },
  { path: "/financeagent", component: <FinanceAgent /> },
  { path: "/timesheets", component: <TimesheetManager /> },
  { path: "/timesheetclient", component: <TimesheetClient /> },
  { path: "/timesheetagent", component: <TimesheetAgent /> },
  { path: "/timesheetform", component: <TimesheetForm /> },
  { path: "/timesheetlist", component: <TimesheetList /> },
  { path: "/timesheetworker", component: <TimesheetWorker /> },
  { path: "/applicationdetail", component: <ApplicationManager /> },
  { path: "/applicationworker", component: <ApplicationWorker /> },
  { path: "/agreementclient", component: <AgreementClient /> },
  { path: "/agreementagent", component: <AgreementAgent /> },
  { path: "/organisationclient", component: <OrganisationClient /> },
  { path: "/organisationagent", component: <OrganisationAgent /> },
  { path: "/users", component: <Users /> },
  { path: "/ctl", component: <CreateEmailTemplateForm /> },
  { path: "/schedule", component: <Schedule /> },
  { path: "/scheduleworker", component: <ScheduleWorker /> },
  { path: "/schedul", component: <Schedul /> },
  { path: "/master", component: <Master /> },
  { path: "/masterclient", component: <MasterClient /> },
  { path: "/masterworker", component: <MasterWorker /> },
  { path: "/masterk", component: <MasterKanban /> },
  { path: "/masterg", component: <MasterGantt /> },
  { path: "/masterw", component: <MasterWorker /> },
  { path: "/masterm", component: <MasterMap /> },

  {
    path: "/mytime",
    component: <CompletedJobsByTimesheetStatus />,
  },
  {
    path: "/approve",
    component: <ApproveTimesheets />,
  },

  {
    path: "/approveclient",
    component: <ApproveClientTimesheets />,
  },

  {
    path: "/approveworker",
    component: <ApproveWorkerTimesheets />,
  },

  //chat
  { path: "/chat", component: <Chat /> },

  { path: "/chat", component: <Chat /> },
  // //calendar
  { path: "/calendar", component: <Calendar /> },

  // //profile
  { path: "/profile", component: <UserProfile /> },
  { path: "/usermanager", component: <UserProfile /> },
  { path: "/adminregister", component: <AdminRegister /> },
  { path: "/clientregister", component: <ClientRegister /> },
  { path: "/activity", component: <ActivityManager /> },

  //Email
  { path: "/email-read", component: <EmailRead /> },
  { path: "/email-template-basic", component: <EmailBasicTemplte /> },
  { path: "/email-template-alert", component: <EmailAlertTemplte /> },
  { path: "/email-template-billing", component: <EmailTemplateBilling /> },
  { path: "/email", component: <Email /> },

  //Invoices
  { path: "/invoices-list", component: <InvoicesList /> },
  { path: "/invoices-detail/:id", component: <InvoiceDetail /> },
  { path: "/invoices-detail", component: <InvoiceDetail /> },
  { path: "/invoicepage", component: <InvoicePage /> },
  { path: "/invoices", component: <InvoiceManager /> },
  { path: "/invoiceclient", component: <InvoiceClient /> },
  { path: "/InvoiceForm", component: <InvoiceForm /> },

  //job
  { path: "/job-grid", component: <JobGrid /> },
  { path: "/joblisting", component: <JobListing /> },
  { path: "/booking", component: <Booking /> },

  { path: "/job-details", component: <JobDetails /> },
  { path: "/job-details/:jobID", component: <JobDetails /> },

  { path: "/job-categories", component: <JobCategories /> },
  { path: "/job-list", component: <JobList /> },
  { path: "/job-apply", component: <ApplyJobs /> },
  { path: "/candidate-overview", component: <CandidateOverview /> },
  { path: "/allocate", component: <Allocate /> },

  // Contacts
  { path: "/contacts-grid", component: <ContactsGrid /> },
  { path: "/contacts-list", component: <ContactsList /> },
  { path: "/contacts-profile", component: <ContactsProfile /> },

  //Charts
  { path: "/apex-charts", component: <ChartApex /> },
  { path: "/chartjs-charts", component: <ChartjsChart /> },
  { path: "/e-charts", component: <EChart /> },
  { path: "/sparkline-charts", component: <SparklineChart /> },
  { path: "/charts-knob", component: <ChartsKnob /> },
  { path: "/re-charts", component: <ReCharts /> },

  // Icons
  { path: "/icons-boxicons", component: <IconBoxicons /> },
  { path: "/icons-dripicons", component: <IconDripicons /> },
  { path: "/icons-materialdesign", component: <IconMaterialdesign /> },
  { path: "/icons-fontawesome", component: <IconFontawesome /> },

  // Tables
  { path: "/tables-basic", component: <BasicTables /> },
  { path: "/tables-datatable", component: <DatatableTables /> },

  // Maps
  { path: "/maps-google", component: <MapsGoogle /> },

  // Forms
  { path: "/form-elements", component: <FormElements /> },
  { path: "/form-layouts", component: <FormLayouts /> },
  { path: "/form-advanced", component: <FormAdvanced /> },
  { path: "/form-editors", component: <FormEditors /> },
  { path: "/form-mask", component: <FormMask /> },
  { path: "/form-repeater", component: <FormRepeater /> },
  { path: "/form-uploads", component: <FormUpload /> },
  { path: "/form-wizard", component: <FormWizard /> },
  { path: "/form-validation", component: <FormValidations /> },

  // Ui
  { path: "/ui-alerts", component: <UiAlert /> },
  { path: "/ui-buttons", component: <UiButtons /> },
  { path: "/ui-cards", component: <UiCards /> },
  { path: "/ui-carousel", component: <UiCarousel /> },
  { path: "/ui-colors", component: <UiColors /> },
  { path: "/ui-dropdowns", component: <UiDropdown /> },
  { path: "/ui-general", component: <UiGeneral /> },
  { path: "/ui-grid", component: <UiGrid /> },
  { path: "/ui-images", component: <UiImages /> },
  { path: "/ui-lightbox", component: <UiLightbox /> },
  { path: "/ui-modals", component: <UiModal /> },
  { path: "/ui-progressbars", component: <UiProgressbar /> },
  { path: "/ui-tabs-accordions", component: <UiTabsAccordions /> },
  { path: "/ui-typography", component: <UiTypography /> },
  { path: "/ui-video", component: <UiVideo /> },
  { path: "/ui-session-timeout", component: <UiSessionTimeout /> },
  { path: "/ui-rating", component: <UiRating /> },
  { path: "/ui-rangeslider", component: <UiRangeSlider /> },
  { path: "/ui-notifications", component: <UiNotifications /> },
  { path: "/ui-offcanvas", component: <UiOffCanvas /> },
  { path: "/ui-utilities", component: <UiUtilitie /> },
  { path: "/ui-placeholders", component: <UiPlaceholders /> },
  { path: "/ui-toasts", component: <UiToasts /> },

  //Utility
  { path: "/pages-starter", component: <PagesStarter /> },
  { path: "/pages-timeline", component: <PagesTimeline /> },
  { path: "/pages-faqs", component: <PagesFaqs /> },
  { path: "/pages-pricing", component: <PagesPricing /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
]

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
  { path: "/confirm", component: <Confirm /> },
  { path: "/privacy", component: <PrivacyPolicy /> },
  { path: "/privacy-choices", component: <PrivacyChoices /> },
  { path: "/unsubscribe", component: <UnsubscribePage /> },
  { path: "/support", component: <Support /> },
  { path: "/home", component: <Home /> },
  { path: "/aboutus", component: <AboutUs /> },
  { path: "/book", component: <BookADemo /> },
  { path: "/calc", component: <ROICalculator /> },
  { path: "/team", component: <OurTeam /> },
  { path: "/story", component: <OurStory /> },
  { path: "/blog", component: <OurBlog /> },
  { path: "/guide", component: <OurGuide /> },
  { path: "/staffing", component: <StaffingService /> },
  { path: "/rota", component: <RotaManagement /> },
  { path: "/digitaltime", component: <DigitalTimesheet /> },
  { path: "/contactus", component: <ContactUs /> },
  { path: "/recruit", component: <Recruitment /> },
  { path: "/wages", component: <WagesSalaries /> },
  { path: "/invoices", component: <Invoices /> },
  { path: "/careers", component: <Careers /> },
  { path: "/press", component: <Press /> },

  { path: "/pages-maintenance", component: <PagesMaintenance /> },
  { path: "/pages-comingsoon", component: <PagesComingsoon /> },
  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },

  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-login-2", component: <Login2 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/pages-register-2", component: <Register2 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/page-recoverpw-2", component: <Recoverpw2 /> },
  { path: "/pages-forgot-pwd", component: <ForgetPwd1 /> },
  { path: "/auth-recoverpw-2", component: <ForgetPwd2 /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
  { path: "/auth-lock-screen-2", component: <LockScreen2 /> },
  { path: "/page-confirm-mail", component: <ConfirmMail /> },
  { path: "/page-confirm-mail-2", component: <ConfirmMail2 /> },
  { path: "/auth-email-verification", component: <EmailVerification /> },
  { path: "/auth-email-verification-2", component: <EmailVerification2 /> },
  { path: "/auth-two-step-verification", component: <TwostepVerification /> },

  {
    path: "/auth-two-step-verification-2",
    component: <TwostepVerification2 />,
  },
]

export { authProtectedRoutes, publicRoutes };
